<template>
    <div class="menulist">
        <div class="menulist-container">
            <div class="menulist-item" v-for="(cItem, cKey) in carrouselItens" :key="cKey" @click="emitEvent(cItem)"
            v-permission="cItem.permission"
            >
                <i :class="`fa fas ${cItem['icon']}`"></i>
                <span v-if="cItem['showBalance']" v-text="getCurrDependent.BALANCE || '0,00'"></span>
                <h3 v-html="fixLength(cItem['display'])"></h3>
            </div>
        </div>
    </div>
</template>
<script >
import { mapGetters } from 'vuex'

export default {
    name: 'MenuListComponent',
    props: ['carrouselItens', 'fieldMap'],
    methods: {
        emitEvent: function (cItem) {
            this.$emit('componentEvent', cItem)
        },
        fixLength: function (text) {
            if (text.includes('#')) {
                return text.replace(/#/g, '<br>')
            }
            return text
        }
    },
    computed: {
        ...mapGetters(['getCurrDependent'])
    }
}
</script>
<style lang="less" scoped>
.menulist {
    position: relative;
    margin: 35px -15px 0 -15px;
    user-select: none;

    .menulist-container {
        max-height: calc(100vh - 95px);
        position: relative;
        overflow-y: auto;
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 7.5px));
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        padding: 0 15px 15px 15px;

        &::-webkit-scrollbar {
            display: none;
        }

        .menulist-item {
            position: relative;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-evenly;
            align-items: center;
            min-height: 90px;
            text-align: center;
            border-radius: 5px;
            border: 1px solid var(--cardBorder);
            background-color: var(--cardBackground);
            box-shadow: 2px 2px 4px 0px var(--cardBorder);
            transition: all linear .2s;
            padding: 10px;

            i {
                font-size: 1.5rem;
                color: var(--iconColor);
            }
            span {
                color: var(--iconColor);
                font-weight: bold;
            }
            &:active{
                box-shadow: 0 0 0 0 var(--cardBorder);
            }
            h3 {
                word-break: break-all;
            }
        }
    }
}
</style>
